import RouteContainer from '../../common/styles/RouteContainer'
import RowSpacer from '../../common/styles/RowSpacer'
import booksitoutIcon from '../../config/BooksitoutIcon'
import RouteTitle from '../../common/RouteTitle/RouteTitle'
import RouteTitleConfig from '../../config/RouteTitleConfig'
// import ProfileListItem from '../appUsers/profiles/ProfileListItem'
// import useAppUserProfiles from '../appUsers/useAppUserProfiles'
import useHtmlTitle from '../../common/useHtmlTitle'
// import ProfileListItemLoading from '../appUsers/profiles/ProfileListItemLoading'
// import CardBodyContentContainer from "../../common/styles/CardBodyContentContainer"
// import InfiniteScroll from 'react-infinite-scroll-component'

const BookRoute = () => {
    useHtmlTitle('전체 서재')

    // const [appUserWithBooks, isLoading, , paging] = useAppUserProfiles(20)

    return (
        <RouteContainer>
            <RouteTitle icon={<booksitoutIcon.book/>} title={'전체 서재'} subTitle={'나만의 서재를 만들어 가고 다른 사람의 서재를 구경해 보세요'}
                        currentKey={'index'} buttons={RouteTitleConfig.Book} rightUi={undefined}/>

            <RowSpacer/>
            {/* {isLoading ? (
                <Loading />
            ) : (
                <InfiniteScroll
                    loader={<Loading />}
                    next={paging.fetchNext}
                    hasMore={paging.hasMore}
                    dataLength={appUserWithBooks.length}
                >
                    {appUserWithBooks.map((appUserWithBook, index) => (
                        <div key={index} className={'ps-1 pe-1'}>
                            <CardBodyContentContainer backgroundColorType={'card'}>
                                <ProfileListItem appUserWithBooks={appUserWithBook}/>
                            </CardBodyContentContainer>
                            <RowSpacer size={10}/>
                        </div>
                    ))}
                </InfiniteScroll>
            )} */}
            <RowSpacer size={40}/>
        </RouteContainer>
    )
}

// const Loading = () => {
//     return (
//         <>
//             {Array.from({length: 10}).map((_, index) => (
//                 <div key={index} className={'ps-1 pe-1'}>
//                     <CardBodyContentContainer backgroundColorType={'card'}>
//                         <ProfileListItemLoading/>
//                     </CardBodyContentContainer>
//                     <RowSpacer size={10}/>
//                 </div>
//             ))}
//         </>
//     )
// }

export default BookRoute
